import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from '../../../../components/Spinner'
import { Container } from './userInfoStyled';
import { Heading, TableWrapper, ButtonWrapper } from 'web/pages/private/Admin/adminStyled'
import { SelectWrapper, InnerBox } from 'web/pages/private/Admin/DashBoard/dashBoardStyled'

import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';

import { CreatePromoCodeApi } from '../../../../../redux/actions/admin';

const CreatePromoCode = ({ togglePage, fetchMyAPI, fetchCheckoutPromoAPI, promoCodeType }) => {

    let dispatch = useDispatch()
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    let fromDate = new Date();
    let toDate = new Date();
    toDate.setDate(toDate.getDate() + 31);
    const [pageValueUpdates, setPageValueUpdates] = useState({
        promoType: 'Free Subscription',
        newPromoCode: '',
        description: '',
        // state values of Free Subscription promo code
        usageCountRegistration: '',
        benefitDurationRegistration: '',
        benefitTypeRegistration: 'Month',
        eligibilityTypeRegistration: 'Everyone',
        validityFromRegistration: fromDate.toISOString().substring(0, 10),
        validityToRegistration: toDate.toISOString().substring(0, 10),
        // state values of checkout promo code
        startDateCheckoutType: fromDate.toISOString().substring(0, 10),
        endDateCheckoutType: toDate.toISOString().substring(0, 10),
        discountTypeCheckoutType: 'PERCENTAGE',
        discountValCheckoutType: '',
        discountMinTransValCheckoutType: '',
        discountMaxTransValCheckoutType: '',
        usageCountCheckoutType: '',
        eligibilityTypeCheckoutType: 'Anyone',
        limitPerLocationCheckoutType: '',
    })
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [alertType, setAlertType] = useState('')
    const toggleModal = () => {
        setModal(!modal);
    }
    const timeSpanSelect = [{ label: 'Days', value: 'Day' }, { label: 'Months', value: 'Month' }, { label: 'Years', value: 'Year' }]

    useEffect(() => {
        setPageValueUpdates({
            ...pageValueUpdates,
            ['promoType']: promoCodeType === 'Registration' ? 'Free Subscription' : 'Checkout'
        })
    }, [promoCodeType])

    const handleChange = (e) => {
        let numberRegex = /^\d*\.?\d{0,2}$/;
        if (e.target.id === "usageCountRegistration" || e.target.id === "usageCountCheckoutType") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 10001)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim()
                })
            }
        } else if (e.target.id === "benefitDurationRegistration") {
            let durationTime = 0
            if (pageValueUpdates.benefitTypeRegistration === 'Day') durationTime = 31
            else if (pageValueUpdates.benefitTypeRegistration === 'Month') durationTime = 12
            else durationTime = 2
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < durationTime)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim()
                })
            }
        } else if (e.target.id === "benefitTypeRegistration") {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value.trim(),
                benefitDurationRegistration: ''
            })
        } else if (e.target.id === "discountTypeCheckoutType") {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value.trim(),
                discountValCheckoutType: ''
            })
        } else if (e.target.id === "discountMinTransValCheckoutType") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 1000000001)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim(),
                    discountMaxTransValCheckoutType: ''
                })
            }
        } else if (e.target.id === "discountMaxTransValCheckoutType") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 1000000001)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim(),
                })
            }
        } else if (e.target.id === "discountValCheckoutType") {
            let maxLimit
            if (pageValueUpdates.discountTypeCheckoutType === 'PERCENTAGE') {
                numberRegex = /^\d*\.?\d{0,3}$/;
                maxLimit = 101;
            }
            if (pageValueUpdates.discountTypeCheckoutType === 'FLAT') maxLimit = 1000000001
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < maxLimit)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim()
                })
            }
        } else if (e.target.id === "limitPerLocationCheckoutType") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 10001)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim(),
                })
            }
        } else if (e.target.id === "description") {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value,
            })
        } else {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value.trim()
            })
        }
    }

    const submitPromoCode = async (e) => {
        let checkFieldsFilled = false

        if (pageValueUpdates.promoType === 'Free Subscription') {
            if (pageValueUpdates.newPromoCode !== '' && pageValueUpdates.usageCountRegistration !== '' && pageValueUpdates.benefitDurationRegistration !== '' && pageValueUpdates.description !== '') {
                checkFieldsFilled = true
            }
        } else if (pageValueUpdates.promoType === 'Checkout') {
            if (pageValueUpdates.newPromoCode !== '' && pageValueUpdates.discountValCheckoutType !== '' && pageValueUpdates.discountMinTransValCheckoutType !== '' &&
                pageValueUpdates.usageCountCheckoutType !== '' && pageValueUpdates.limitPerLocationCheckoutType !== '' && pageValueUpdates.description !== '') {
                checkFieldsFilled = true
            }
            if (pageValueUpdates.discountTypeCheckoutType === 'PERCENTAGE' && pageValueUpdates.discountMaxTransValCheckoutType === "") checkFieldsFilled = false
        }

        if (pageValueUpdates.promoType === 'Free Subscription' && (parseInt(pageValueUpdates.usageCountRegistration) === 0 || parseInt(pageValueUpdates.benefitDurationRegistration) === 0)) {
            setModalContent("Value should be greater than 0.");
            toggleModal();
        } else if (pageValueUpdates.promoType === 'Checkout' && (parseInt(pageValueUpdates.usageCountCheckoutType) === 0 || parseInt(pageValueUpdates.limitPerLocationCheckoutType) === 0 || parseInt(pageValueUpdates.discountValue) === 0 || parseInt(pageValueUpdates.discountMinTransValCheckoutType) === 0)) {
            setModalContent("Value should be greater than 0.");
            toggleModal();
        } else if (pageValueUpdates.promoType === 'Checkout' && pageValueUpdates.discountTypeCheckoutType === 'PERCENTAGE' && (parseInt(pageValueUpdates.discountMaxTransValCheckoutType) === 0)) {
            setModalContent("Value should be greater than 0.");
            toggleModal();
        } else if (pageValueUpdates.promoType === 'Checkout' && pageValueUpdates.discountTypeCheckoutType === 'PERCENTAGE' && !(parseInt(pageValueUpdates.discountMaxTransValCheckoutType) > parseInt(pageValueUpdates.discountMinTransValCheckoutType))) {
            setModalContent("Max. Trans. value should be greater than Min. Trans. value.");
            toggleModal();
        } else if (checkFieldsFilled) {
            let data
            if (pageValueUpdates.promoType === 'Free Subscription') {
                data = {
                    generatePromoCode: pageValueUpdates.newPromoCode,
                    limitUsageCount: pageValueUpdates.usageCount === '' ? 0 : pageValueUpdates.usageCountRegistration,
                    promoType: pageValueUpdates.promoType,
                    timeSpanForBenefits: {
                        number: pageValueUpdates.benefitDurationRegistration === '' ? 0 : pageValueUpdates.benefitDurationRegistration,
                        timeDMY: pageValueUpdates.benefitTypeRegistration
                    },
                    customerEligibility: pageValueUpdates.eligibilityTypeRegistration,
                    applyStartDate: pageValueUpdates.validityFromRegistration,
                    applyEndDate: pageValueUpdates.validityToRegistration,
                    description: pageValueUpdates.description
                }
            } else if (pageValueUpdates.promoType === 'Checkout') {
                data = {
                    promoType: pageValueUpdates.promoType,
                    applyStartDate: pageValueUpdates.startDateCheckoutType,
                    applyEndDate: pageValueUpdates.endDateCheckoutType,
                    generatePromoCode: pageValueUpdates.newPromoCode,
                    discountType: pageValueUpdates.discountTypeCheckoutType,
                    discountValue: pageValueUpdates.discountValCheckoutType,
                    minTransValue: pageValueUpdates.discountMinTransValCheckoutType,
                    maxTransValue: pageValueUpdates.discountMaxTransValCheckoutType,
                    limitUsageCount: pageValueUpdates.usageCountCheckoutType,
                    customerEligibility: pageValueUpdates.eligibilityTypeCheckoutType,
                    limitPerLocation: pageValueUpdates.limitPerLocationCheckoutType,
                    description: pageValueUpdates.description
                }
            }
            let response = await dispatch(CreatePromoCodeApi(data))
            if (response.status === 'SUCCESS') {
                setModalContent(response.message);
                if (pageValueUpdates.promoType === 'Free Subscription') setAlertType('createRegistrationPromoCode')
                else setAlertType('createCheckoutPromoCode')
                toggleModal();
            } else {
                if (response.statusCode === 401) {
                    localStorage.removeItem('token')
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(response.data?.message || response.message || 'Something went wrong, please try after sometime.')
                    toggleModal();
                }
            }
        } else {
            setModalContent("Please fill the required fields.");
            setAlertType('')
            toggleModal();
        }
    }

    return (
        <div>
            <Container>

                {loaderVisible && <Spinner />}
                <TableWrapper>
                    <Heading>
                        <h3>Promo Type</h3>
                    </Heading>
                    <InnerBox>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <SelectWrapper>
                                        <label>Promo Type<span className='star'>*</span></label>
                                        <select id='promoType' value={pageValueUpdates.promoType}
                                            onChange={handleChange}>
                                            <option value='Free Subscription'>Free Subscription</option>
                                            <option value='Checkout'>Checkout</option>
                                        </select>
                                    </SelectWrapper>
                                </div>
                                {pageValueUpdates.promoType === 'Free Subscription' ?
                                    <>
                                        <div className='col-md-3'>
                                            <SelectWrapper>
                                                <label>Time Span for benefits<span className='star'>*</span></label>
                                                <div className='row' style={{ marginLeft: '0px' }}>
                                                    <input style={{ minWidth: '130px', width: '130px' }} required id='benefitDurationRegistration' value={pageValueUpdates.benefitDurationRegistration} placeholder='No. of' onChange={handleChange} />
                                                    <label>&nbsp;</label>
                                                    <select style={{ minWidth: '130px' }} id='benefitTypeRegistration' value={pageValueUpdates.benefitTypeRegistration}
                                                        onChange={handleChange}
                                                    >
                                                        {timeSpanSelect.map(val => (
                                                            <option value={val.value}>{val.label}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </SelectWrapper>
                                        </div>
                                        <div className='col-md-6'>
                                            <SelectWrapper>
                                                <label>Validity<span className='star'>*</span></label>
                                                <div className='row' style={{ marginLeft: '0px' }}>
                                                    <input type='date' max={pageValueUpdates.validityToRegistration} id='validityFromRegistration' value={pageValueUpdates.validityFromRegistration} onChange={handleChange} />
                                                    <label style={{ margin: '6px' }}>To&nbsp;</label>
                                                    <input type='date' min={pageValueUpdates.validityFromRegistration} id='validityToRegistration' value={pageValueUpdates.validityToRegistration} onChange={handleChange} />
                                                </div>
                                            </SelectWrapper>
                                        </div>
                                    </>
                                    :
                                    pageValueUpdates.promoType === 'Checkout' &&
                                    <>
                                        <div className='col-md-2'>
                                            <SelectWrapper>
                                                <label>Start Date<span className='star'>*</span></label>
                                                <div className='row' style={{ marginLeft: '0px' }}>
                                                    <input type='date' max={pageValueUpdates.endDateCheckoutType} id='startDateCheckoutType' value={pageValueUpdates.startDateCheckoutType} onChange={handleChange} />
                                                </div>
                                            </SelectWrapper>
                                        </div>
                                        <div className='col-md-2'>
                                            <SelectWrapper>
                                                <label>End Date<span className='star'>*</span></label>
                                                <div className='row' style={{ marginLeft: '0px' }}>
                                                    <input type='date' min={pageValueUpdates.startDateCheckoutType} id='endDateCheckoutType' value={pageValueUpdates.endDateCheckoutType} onChange={handleChange} />
                                                </div>
                                            </SelectWrapper>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </InnerBox>
                </TableWrapper>

                <TableWrapper>
                    <Heading>
                        <h3>Generate Promo Code</h3>
                    </Heading>
                    <InnerBox>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <SelectWrapper>
                                        <label>Generate Promo Code<span className='star'>*</span></label>
                                        <input required id='newPromoCode' placeholder='Enter a new code...' value={pageValueUpdates.newPromoCode.substring(0, 50)} onChange={handleChange} />
                                    </SelectWrapper>
                                </div>
                                {pageValueUpdates.promoType === 'Free Subscription' ?
                                    <div className='col-md-2'>
                                        <SelectWrapper>
                                            <label>Limit Usage Count<span className='star'>*</span></label>
                                            <input required id='usageCountRegistration' placeholder='Usage Count' value={pageValueUpdates.usageCountRegistration} onChange={handleChange} />
                                        </SelectWrapper>
                                    </div>
                                    :
                                    pageValueUpdates.promoType === 'Checkout' &&
                                    <>
                                        <div style={{ width: '130px', marginLeft: '15px' }}>
                                            <SelectWrapper>
                                                <label>Discount Type<span className='star'>*</span></label>
                                                <select style={{ minWidth: '130px' }} id='discountTypeCheckoutType' value={pageValueUpdates.discountTypeCheckoutType}
                                                    onChange={handleChange}>
                                                    <option value='PERCENTAGE'>Percentage</option>
                                                    <option value='FLAT'>FLAT</option>
                                                </select>
                                            </SelectWrapper>
                                        </div>
                                        <div style={{ width: '160px', marginLeft: '15px' }}>
                                            <SelectWrapper>
                                                <label>Discount Value<span className='star'>*</span></label>
                                                <div style={{ position: 'relative', display: 'flex' }}>
                                                    <span style={{ position: 'absolute', padding: '10px', borderRight: '1px solid #bcbcbc', top: '3px' }}>{pageValueUpdates.discountTypeCheckoutType === 'PERCENTAGE' ? '%' : '$'}</span>
                                                    <input style={{ minWidth: '130px', paddingLeft: '40px' }} required id='discountValCheckoutType' value={pageValueUpdates.discountValCheckoutType} onChange={handleChange} />
                                                </div>
                                            </SelectWrapper>
                                        </div>
                                        <div style={{ width: '160px', marginLeft: '15px' }}>
                                            <SelectWrapper>
                                                <label>Min. Trans. Value<span className='star'>*</span></label>
                                                <div style={{ position: 'relative', display: 'flex' }}>
                                                    <span style={{ position: 'absolute', padding: '10px', borderRight: '1px solid #bcbcbc', top: '3px' }}>$</span>
                                                    <input style={{ minWidth: '160px', paddingLeft: '40px' }} required id='discountMinTransValCheckoutType' value={pageValueUpdates.discountMinTransValCheckoutType} onChange={handleChange} />
                                                </div>
                                            </SelectWrapper>
                                        </div>
                                        {pageValueUpdates.discountTypeCheckoutType === 'PERCENTAGE' &&
                                            <div style={{ width: '160px', marginLeft: '15px' }}>
                                                <SelectWrapper>
                                                    <label>Max. Trans. Value<span className='star'>*</span></label>
                                                    <div style={{ position: 'relative', display: 'flex' }}>
                                                        <span style={{ position: 'absolute', padding: '10px', borderRight: '1px solid #bcbcbc', top: '3px' }}>$</span>
                                                        <input style={{ minWidth: '160px', paddingLeft: '40px' }} required id='discountMaxTransValCheckoutType' value={pageValueUpdates.discountMaxTransValCheckoutType} onChange={handleChange} />
                                                    </div>
                                                </SelectWrapper>
                                            </div>
                                        }
                                        <div className='col-md-2'>
                                            <SelectWrapper>
                                                <label>Limit Usage Count<span className='star'>*</span></label>
                                                <input required id='usageCountCheckoutType' placeholder='Usage Count' value={pageValueUpdates.usageCountCheckoutType} onChange={handleChange} />
                                            </SelectWrapper>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </InnerBox>
                </TableWrapper>

                <TableWrapper>
                    <Heading>
                        <h3>Customer Eligibility</h3>
                    </Heading>
                    <InnerBox>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <SelectWrapper>
                                        <label>Eligibility Type<span className='star'>*</span></label>
                                        {pageValueUpdates.promoType === 'Checkout' ?
                                            <select id='eligibilityTypeCheckoutType' value={pageValueUpdates.eligibilityTypeCheckoutType}
                                                onChange={handleChange}>
                                                {/* <option value='OneTime'>One Time</option> */}
                                                <option value='Anyone'>Anyone</option>
                                            </select>
                                            :
                                            <select id='eligibilityTypeRegistration' value={pageValueUpdates.eligibilityTypeRegistration}
                                                onChange={handleChange}>
                                                <option value='Everyone'>Everyone</option>
                                                <option value='New Registration'>New Registration</option>
                                            </select>
                                        }
                                    </SelectWrapper>
                                </div>
                                {pageValueUpdates.promoType === 'Checkout' &&
                                    <div className='col-md-2'>
                                        <SelectWrapper>
                                            <label>Limit Per Location<span className='star'>*</span></label>
                                            <input required id='limitPerLocationCheckoutType' value={pageValueUpdates.limitPerLocationCheckoutType} onChange={handleChange} />
                                        </SelectWrapper>
                                    </div>
                                }
                                <div className='col-md-4'>
                                    <SelectWrapper>
                                        <label>Description<span className='star'>*</span></label>
                                        <input required id='description' value={pageValueUpdates.description} onChange={handleChange} />
                                    </SelectWrapper>
                                </div>
                            </div>
                        </div>
                    </InnerBox>
                </TableWrapper>
                <ButtonWrapper>
                    <Button
                        type='app-green-button submitBtn'
                        handleClick={() => togglePage('PromoCode')}
                    >
                        Back
                    </Button>
                    <Button
                        type='app-green-button submitBtn'
                        handleClick={e => submitPromoCode(e)}
                    >
                        Create Promo Code
                    </Button>
                </ButtonWrapper>
            </Container>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=''
                content={modalContent}
                alertType={alertType}
                callBackAlert={() => {
                    if (alertType === 'createRegistrationPromoCode') fetchMyAPI()
                    else if (alertType === 'createCheckoutPromoCode') fetchCheckoutPromoAPI()
                    togglePage('PromoCode')
                }}
            />
        </div >
    )
};

export default CreatePromoCode;